program facil_web;

{$R *.dres}

uses
  Vcl.Forms,
  XData.Web.Connection,
  ConnectionModule in 'ConnectionModule.pas',
  View.Main in 'View.Main.pas'{*.html},
  View.Home in 'View.Home.pas'{*.html},
  View.Itens_Cupons.List in 'View.Itens_Cupons.List.pas'{*.html},
  View.Itens_Cupons.Edit in 'View.Itens_Cupons.Edit.pas'{*.html},
  View.Itens_Saida.List in 'View.Itens_Saida.List.pas'{*.html},
  View.Itens_Saida.Edit in 'View.Itens_Saida.Edit.pas'{*.html},
  View.Cst_Ipi.List in 'View.Cst_Ipi.List.pas'{*.html},
  View.Cst_Ipi.Edit in 'View.Cst_Ipi.Edit.pas'{*.html},
  View.Cfop.List in 'View.Cfop.List.pas'{*.html},
  View.Cfop.Edit in 'View.Cfop.Edit.pas'{*.html},
  View.Codigo_bc_Piscofins.List in 'View.Codigo_bc_Piscofins.List.pas'{*.html},
  View.Codigo_bc_Piscofins.Edit in 'View.Codigo_bc_Piscofins.Edit.pas'{*.html},
  View.Contadores.List in 'View.Contadores.List.pas'{*.html},
  View.Contadores.Edit in 'View.Contadores.Edit.pas'{*.html},
  View.Cst.List in 'View.Cst.List.pas'{*.html},
  View.Cst.Edit in 'View.Cst.Edit.pas'{*.html},
  View.Recebimentos.List in 'View.Recebimentos.List.pas'{*.html},
  View.Recebimentos.Edit in 'View.Recebimentos.Edit.pas'{*.html},
  View.Cst_Pis.List in 'View.Cst_Pis.List.pas'{*.html},
  View.Cst_Pis.Edit in 'View.Cst_Pis.Edit.pas'{*.html},
  View.Plano_Contas.List in 'View.Plano_Contas.List.pas'{*.html},
  View.Plano_Contas.Edit in 'View.Plano_Contas.Edit.pas'{*.html},
  View.Modalidades.List in 'View.Modalidades.List.pas'{*.html},
  View.Modalidades.Edit in 'View.Modalidades.Edit.pas'{*.html},
  View.Modulos_Data_Base.List in 'View.Modulos_Data_Base.List.pas'{*.html},
  View.Modulos_Data_Base.Edit in 'View.Modulos_Data_Base.Edit.pas'{*.html},
  View.Apagar.List in 'View.Apagar.List.pas'{*.html},
  View.Apagar.Edit in 'View.Apagar.Edit.pas'{*.html},
  View.Sincronizacao_Service.List in 'View.Sincronizacao_Service.List.pas'{*.html},
  View.Sincronizacao_Service.Edit in 'View.Sincronizacao_Service.Edit.pas'{*.html},
  View.Origem_Csosn.List in 'View.Origem_Csosn.List.pas'{*.html},
  View.Origem_Csosn.Edit in 'View.Origem_Csosn.Edit.pas'{*.html},
  View.Aliado.List in 'View.Aliado.List.pas'{*.html},
  View.Aliado.Edit in 'View.Aliado.Edit.pas'{*.html},
  View.Itens_Entrada.List in 'View.Itens_Entrada.List.pas'{*.html},
  View.Itens_Entrada.Edit in 'View.Itens_Entrada.Edit.pas'{*.html},
  View.UF.List in 'View.UF.List.pas'{*.html},
  View.UF.Edit in 'View.UF.Edit.pas'{*.html},
  View.Cidade.List in 'View.Cidade.List.pas'{*.html},
  View.Cidade.Edit in 'View.Cidade.Edit.pas'{*.html},
  View.Parceiros.List in 'View.Parceiros.List.pas'{*.html},
  View.Parceiros.Edit in 'View.Parceiros.Edit.pas'{*.html},
  View.Unidades.List in 'View.Unidades.List.pas'{*.html},
  View.Unidades.Edit in 'View.Unidades.Edit.pas'{*.html},
  View.Pagamentos.List in 'View.Pagamentos.List.pas'{*.html},
  View.Pagamentos.Edit in 'View.Pagamentos.Edit.pas'{*.html},
  View.Grupos.List in 'View.Grupos.List.pas'{*.html},
  View.Grupos.Edit in 'View.Grupos.Edit.pas'{*.html},
  View.Plano_Contas3.List in 'View.Plano_Contas3.List.pas'{*.html},
  View.Plano_Contas3.Edit in 'View.Plano_Contas3.Edit.pas'{*.html},
  View.Plano_Contas_Contabil.List in 'View.Plano_Contas_Contabil.List.pas'{*.html},
  View.Plano_Contas_Contabil.Edit in 'View.Plano_Contas_Contabil.Edit.pas'{*.html},
  View.Modulos.List in 'View.Modulos.List.pas'{*.html},
  View.Modulos.Edit in 'View.Modulos.Edit.pas'{*.html},
  View.Segmento.List in 'View.Segmento.List.pas'{*.html},
  View.Segmento.Edit in 'View.Segmento.Edit.pas'{*.html},
  View.Grade_Produtos.List in 'View.Grade_Produtos.List.pas'{*.html},
  View.Grade_Produtos.Edit in 'View.Grade_Produtos.Edit.pas'{*.html},
  View.Pdvs.List in 'View.Pdvs.List.pas'{*.html},
  View.Pdvs.Edit in 'View.Pdvs.Edit.pas'{*.html},
  View.Vendas.List in 'View.Vendas.List.pas'{*.html},
  View.Vendas.Edit in 'View.Vendas.Edit.pas'{*.html},
  View.Areceber.List in 'View.Areceber.List.pas'{*.html},
  View.Areceber.Edit in 'View.Areceber.Edit.pas'{*.html},
  View.Clientes.List in 'View.Clientes.List.pas'{*.html},
  View.Clientes.Edit in 'View.Clientes.Edit.pas'{*.html},
  View.Compras.List in 'View.Compras.List.pas'{*.html},
  View.Compras.Edit in 'View.Compras.Edit.pas'{*.html},
  View.Plano_Contas2.List in 'View.Plano_Contas2.List.pas'{*.html},
  View.Plano_Contas2.Edit in 'View.Plano_Contas2.Edit.pas'{*.html},
  View.data_base.List in 'View.data_base.List.pas'{*.html},
  View.data_base.Edit in 'View.data_base.Edit.pas'{*.html},
  View.Funcionarios.List in 'View.Funcionarios.List.pas'{*.html},
  View.Funcionarios.Edit in 'View.Funcionarios.Edit.pas'{*.html},
  View.Nfce.List in 'View.Nfce.List.pas'{*.html},
  View.Nfce.Edit in 'View.Nfce.Edit.pas'{*.html},
  View.Grade_Descricoes.List in 'View.Grade_Descricoes.List.pas'{*.html},
  View.Grade_Descricoes.Edit in 'View.Grade_Descricoes.Edit.pas'{*.html},
  View.Plano_Contas1.List in 'View.Plano_Contas1.List.pas'{*.html},
  View.Plano_Contas1.Edit in 'View.Plano_Contas1.Edit.pas'{*.html},
  View.Produtos.List in 'View.Produtos.List.pas'{*.html},
  View.Produtos.Edit in 'View.Produtos.Edit.pas'{*.html},
  View.Sincronizacao_Logs.List in 'View.Sincronizacao_Logs.List.pas'{*.html},
  View.Sincronizacao_Logs.Edit in 'View.Sincronizacao_Logs.Edit.pas'{*.html},
  View.Csosn.List in 'View.Csosn.List.pas'{*.html},
  View.Csosn.Edit in 'View.Csosn.Edit.pas'{*.html},
  View.Usuarios.List in 'View.Usuarios.List.pas'{*.html},
  View.Usuarios.Edit in 'View.Usuarios.Edit.pas'{*.html},
  View.Grade_Colunas.List in 'View.Grade_Colunas.List.pas'{*.html},
  View.Grade_Colunas.Edit in 'View.Grade_Colunas.Edit.pas'{*.html},
  View.Grade_Linhas.List in 'View.Grade_Linhas.List.pas'{*.html},
  View.Grade_Linhas.Edit in 'View.Grade_Linhas.Edit.pas'{*.html},
  View.Aliquotas.List in 'View.Aliquotas.List.pas'{*.html},
  View.Aliquotas.Edit in 'View.Aliquotas.Edit.pas'{*.html},
  View.Cst_Cofins.List in 'View.Cst_Cofins.List.pas'{*.html},
  View.Cst_Cofins.Edit in 'View.Cst_Cofins.Edit.pas'{*.html},
  View.Status_Titulos.List in 'View.Status_Titulos.List.pas'{*.html},
  View.Status_Titulos.Edit in 'View.Status_Titulos.Edit.pas'{*.html},
  View.Bancos.List in 'View.Bancos.List.pas'{*.html},
  View.Bancos.Edit in 'View.Bancos.Edit.pas'{*.html},
  View.Subgrupos.List in 'View.Subgrupos.List.pas'{*.html},
  View.Subgrupos.Edit in 'View.Subgrupos.Edit.pas'{*.html},
  View.Nfe.List in 'View.Nfe.List.pas'{*.html},
  View.Nfe.Edit in 'View.Nfe.Edit.pas'{*.html},
  View.Fornecedores.List in 'View.Fornecedores.List.pas'{*.html},
  View.Fornecedores.Edit in 'View.Fornecedores.Edit.pas'{*.html},
  View.Contas.List in 'View.Contas.List.pas'{*.html},
  View.Contas.Edit in 'View.Contas.Edit.pas'{*.html},
  View.Desoneracao_Icms.List in 'View.Desoneracao_Icms.List.pas'{*.html},
  View.Desoneracao_Icms.Edit in 'View.Desoneracao_Icms.Edit.pas'{*.html},
  View.Codigo_Credito_Piscofins.List in 'View.Codigo_Credito_Piscofins.List.pas'{*.html},
  View.Codigo_Credito_Piscofins.Edit in 'View.Codigo_Credito_Piscofins.Edit.pas'{*.html},
  View.Cupons.List in 'View.Cupons.List.pas'{*.html},
  View.Cupons.Edit in 'View.Cupons.Edit.pas'{*.html},
  View.Nfe_Lote.List in 'View.Nfe_Lote.List.pas'{*.html},
  View.Nfe_Lote.Edit in 'View.Nfe_Lote.Edit.pas'{*.html},
  View.Crud.Container in 'View.Crud.Container.pas'{*.html},
  UConstantes in 'UConstantes.pas',
  View.Lancamentos.Edit in 'View.Lancamentos.Edit.pas'{*.html},
  View.Lancamentos.List in 'View.Lancamentos.List.pas'{*.html},
  View.Tipos.Edit in 'View.Tipos.Edit.pas'{*.html},
  View.Tipos.List in 'View.Tipos.List.pas'{*.html},
  View.Banco_Carteiras.Edit in 'View.Banco_Carteiras.Edit.pas'{*.html},
  View.Banco_Carteiras.List in 'View.Banco_Carteiras.List.pas'{*.html},
  View.Boletos.Edit in 'View.Boletos.Edit.pas'{*.html},
  View.Boletos.List in 'View.Boletos.List.pas'{*.html},
  View.Facil_Planos.Edit in 'View.Facil_Planos.Edit.pas',
  View.Facil_Planos.List in 'View.Facil_Planos.List.pas',
  View.Facil_Planos_Aliados.Edit in 'View.Facil_Planos_Aliados.Edit.pas',
  View.Facil_Planos_Aliados.List in 'View.Facil_Planos_Aliados.List.pas',
  UHelperServer in 'UHelperServer.pas',
  View.Erros_Catalogados.Edit in 'View.Erros_Catalogados.Edit.pas'{*.html},
  View.Erros_Catalogados.List in 'View.Erros_Catalogados.List.pas'{*.html},
  View.Operadoras_Cartao.List in 'View.Operadoras_Cartao.List.pas'{*.html},
  View.Operadoras_Cartao.Edit in 'View.Operadoras_Cartao.Edit.pas'{*.html},
  View.Scripts.Edit in 'View.Scripts.Edit.pas'{*.html},
  View.Scripts.List in 'View.Scripts.List.pas'{*.html},
  View.Scripts_Aliados.Edit in 'View.Scripts_Aliados.Edit.pas'{*.html},
  View.Scripts_Aliados.List in 'View.Scripts_Aliados.List.pas'{*.html},
  View.Versoes.Edit in 'View.Versoes.Edit.pas'{*.html},
  View.Versoes.List in 'View.Versoes.List.pas'{*.html},
  View.Provedores.Edit in 'View.Provedores.Edit.pas'{*.html},
  View.Provedores.List in 'View.Provedores.List.pas'{*.html},
  View.Cidade_Provedor in 'View.Cidade_Provedor.pas'{*.html},
  View.Logs_Sistema.Edit in 'View.Logs_Sistema.Edit.pas'{*.html},
  View.Cfop_Configuracoes.Edit in 'View.Cfop_Configuracoes.Edit.pas'{*.html},
  View.Cfop_Configuracoes.List in 'View.Cfop_Configuracoes.List.pas'{*.html},
  View.Consulta_Sistema in 'View.Consulta_Sistema.pas'{*.html},
  View.Ncm.Edit in 'View.Ncm.Edit.pas'{*.html},
  View.Ncm.List in 'View.Ncm.List.pas'{*.html},
  View.Rt_Ibs_Cbs_Cst.Edit in 'View.Rt_Ibs_Cbs_Cst.Edit.pas'{*.html},
  View.Rt_Ibs_Cbs_Cst.List in 'View.Rt_Ibs_Cbs_Cst.List.pas'{*.html},
  View.Rt_Is_Cst.Edit in 'View.Rt_Is_Cst.Edit.pas'{*.html},
  View.Rt_Is_Cst.List in 'View.Rt_Is_Cst.List.pas'{*.html},
  View.Promocoes.Edit in 'View.Promocoes.Edit.pas'{*.html},
  View.Promocoes.List in 'View.Promocoes.List.pas'{*.html},
  UExportacoes in 'D:\Automacao\projetos\development\projects\classes_facil_sistemas\classes_projetos_web\UExportacoes.pas',
  UUtils in 'D:\Automacao\projetos\development\projects\classes_facil_sistemas\classes_projetos_web\UUtils.pas',
  View.Produtos_Associacao.List in 'View.Produtos_Associacao.List.pas'{*.html},
  UDadosUsuarioVO in 'D:\Automacao\projetos\development\projects\classes_facil_sistemas\classes_projetos_web\UDadosUsuarioVO.pas',
  UWeb.Enum in 'D:\Automacao\projetos\development\projects\classes_facil_sistemas\classes_projetos_web\UWeb.Enum.pas',
  UFrameAssociacaoProdutos in 'UFrameAssociacaoProdutos.pas'{*.html},
  View.UserProfile in 'D:\Automacao\projetos\development\projects\classes_facil_sistemas\classes_projetos_web\Forms\View.UserProfile.pas'{*.html},
  View.Dialog in 'D:\Automacao\projetos\development\projects\classes_facil_sistemas\classes_projetos_web\Forms\View.Dialog.pas'{*.html},
  View.Gerenciar.Usuario in 'D:\Automacao\projetos\development\projects\classes_facil_sistemas\classes_projetos_web\Forms\View.Gerenciar.Usuario.pas'{*.html},
  View.Login in 'D:\Automacao\projetos\development\projects\classes_facil_sistemas\classes_projetos_web\Forms\View.Login.pas'{*.html},
  View.Logs_Sistema.List in 'D:\Automacao\projetos\development\projects\classes_facil_sistemas\classes_projetos_web\Forms\View.Logs_Sistema.List.pas'{*.html},
  App.Config in 'D:\Automacao\projetos\development\projects\classes_facil_sistemas\classes_projetos_web\core\App.Config.pas',
  App.Types in 'D:\Automacao\projetos\development\projects\classes_facil_sistemas\classes_projetos_web\core\App.Types.pas',
  Auth.Service in 'D:\Automacao\projetos\development\projects\classes_facil_sistemas\classes_projetos_web\core\Auth.Service.pas',
  Crud.Utils in 'D:\Automacao\projetos\development\projects\classes_facil_sistemas\classes_projetos_web\core\Crud.Utils.pas',
  Dataset.Plugins in 'D:\Automacao\projetos\development\projects\classes_facil_sistemas\classes_projetos_web\core\Dataset.Plugins.pas',
  Grid.Plugins in 'D:\Automacao\projetos\development\projects\classes_facil_sistemas\classes_projetos_web\core\Grid.Plugins.pas',
  Grid.Settings in 'D:\Automacao\projetos\development\projects\classes_facil_sistemas\classes_projetos_web\core\Grid.Settings.pas',
  Paginator.Plugins in 'D:\Automacao\projetos\development\projects\classes_facil_sistemas\classes_projetos_web\core\Paginator.Plugins.pas',
  View.Fs_Prod_Categorias.Edit in 'View.Fs_Prod_Categorias.Edit.pas'{*.html},
  View.Fs_Prod_Categorias.List in 'View.Fs_Prod_Categorias.List.pas'{*.html},
  View.Fs_Prod_SubCategorias.Edit in 'View.Fs_Prod_SubCategorias.Edit.pas'{*.html},
  View.Fs_Prod_SubCategorias.List in 'View.Fs_Prod_SubCategorias.List.pas'{*.html},
  View.Fs_Prod_Departamentos.Edit in 'View.Fs_Prod_Departamentos.Edit.pas'{*.html},
  View.Fs_Prod_Departamentos.List in 'View.Fs_Prod_Departamentos.List.pas'{*.html},
  View.Fs_Prod_SubDepartamentos.Edit in 'View.Fs_Prod_SubDepartamentos.Edit.pas'{*.html},
  View.Fs_Prod_SubDepartamentos.List in 'View.Fs_Prod_SubDepartamentos.List.pas'{*.html},
  View.Fs_Prod_Fabricantes.Edit in 'View.Fs_Prod_Fabricantes.Edit.pas'{*.html},
  View.Fs_Prod_Fabricantes.List in 'View.Fs_Prod_Fabricantes.List.pas'{*.html},
  View.Fs_Prod_Marcas.Edit in 'View.Fs_Prod_Marcas.Edit.pas'{*.html},
  View.Fs_Prod_Marcas.List in 'View.Fs_Prod_Marcas.List.pas'{*.html},
  View.Fs_Prod_Produtos.Edit in 'View.Fs_Prod_Produtos.Edit.pas'{*.html},
  View.Fs_Prod_Produtos.List in 'View.Fs_Prod_Produtos.List.pas'{*.html},
  View.Fs_Prod_Caracteristicas.Edit in 'View.Fs_Prod_Caracteristicas.Edit.pas'{*.html},
  View.Fs_Prod_Caracteristicas.List in 'View.Fs_Prod_Caracteristicas.List.pas'{*.html},
  UFramePermissoesUsuario in 'UFramePermissoesUsuario.pas'{*.html},
  View.ErrorPage in 'D:\Automacao\projetos\development\projects\classes_facil_sistemas\classes_projetos_web\Forms\View.ErrorPage.pas'{*.html},
  UPersonalizacao_Tabela in 'D:\Automacao\projetos\development\projects\classes_facil_sistemas\classes_projetos_web\UPersonalizacao_Tabela.pas',
  UPersonalizacao_Tabela.Interfaces in 'D:\Automacao\projetos\development\projects\classes_facil_sistemas\classes_projetos_web\UPersonalizacao_Tabela.Interfaces.pas',
  View.Nbs.Edit in 'View.Nbs.Edit.pas'{*.html},
  View.Nbs.List in 'View.Nbs.List.pas'{*.html},
  View.Servicos_Nacional.Edit in 'View.Servicos_Nacional.Edit.pas'{*.html},
  View.Servicos_Nacional.List in 'View.Servicos_Nacional.List.pas'{*.html},
  UFrameFinanceiroCliente in 'UFrameFinanceiroCliente.pas'{*.html},
  UFrameFinanceiroFornecedor in 'UFrameFinanceiroFornecedor.pas'{*.html},
  View.Rt_Credito_Presumido.Edit in 'View.Rt_Credito_Presumido.Edit.pas'{*.html},
  View.Rt_Credito_Presumido.List in 'View.Rt_Credito_Presumido.List.pas'{*.html},
  UFrameDataBase in 'UFrameDataBase.pas'{*.html},
  View.Api_Veiculos.List in 'View.Api_Veiculos.List.pas',
  View.Api_Cpfs.List in 'View.Api_Cpfs.List.pas'{*.html},
  View.Modulos_Acesso.List in 'View.Modulos_Acesso.List.pas'{*.html},
  View.Nfse.Edit in 'View.Nfse.Edit.pas'{*.html},
  View.Nfse.List in 'View.Nfse.List.pas'{*.html},
  View.Servicos.Edit in 'View.Servicos.Edit.pas'{*.html},
  View.Servicos.List in 'View.Servicos.List.pas'{*.html},
  View.Vendas_Servicos.Edit in 'View.Vendas_Servicos.Edit.pas'{*.html},
  View.Vendas_Servicos.List in 'View.Vendas_Servicos.List.pas'{*.html},
  View.Data_Base_Logs.Edit in 'View.Data_Base_Logs.Edit.pas'{*.html},
  View.Data_Base_Logs.List in 'View.Data_Base_Logs.List.pas'{*.html},
  View.Sincronizacao_Servidor_Retaguarda.Edit in 'View.Sincronizacao_Servidor_Retaguarda.Edit.pas'{*.html},
  View.Sincronizacao_Servidor_Retaguarda.List in 'View.Sincronizacao_Servidor_Retaguarda.List.pas'{*.html};

{$R *.res}

procedure DisplayLoginView(AMessage: string = ''); forward;

procedure DisplayMainView;

  procedure ConnectProc;
  begin
    if Assigned(FViewLogin) then
      FViewLogin.Free;
    TFViewMain.Display('', @DisplayLoginView);
  end;

begin
  if not DMConnection.ApiConnection.Connected then
    DMConnection.ApiConnection.Open(@ConnectProc)
  else
    ConnectProc;
end;

procedure DisplayLoginView(AMessage: string);
begin
  AuthService.Logout;
  DMConnection.ApiConnection.Connected := False;
  if Assigned(FViewMain) then
    FViewMain.Free;
  TFViewLogin.Display(AMessage, @DisplayMainView);
end;

procedure UnauthorizedAccessProc(AMessage: string);
begin
  DisplayLoginView(AMessage);
end;


procedure StartApplication;
begin
  if (not AuthService.Authenticated) or AuthService.TokenExpired then
    DisplayLoginView
  else
    DisplayMainView;
end;

begin
  Application.Initialize;
  Application.ErrorType := TApplicationErrorType.aeSilent;
  Application.MainFormOnTaskbar := True;
  Application.CreateFormDirect(TDMConnection, DMConnection);
  Application.Run;


  if (Application.hash = 'consultar-cidades-nfse') or (Application.hash = '/consultar-cidades-nfse') then
  begin
    DMConnection.IniciarCidadesProvedorConnection;

    if Assigned(FViewMain) then
      FViewMain.Free;

    TfrmCidadeProvedor.Display('', @DisplayMainView);
  end
  else if (Pos('recuperar-senha', Application.hash) > 0) or (Pos('ativacao-de-cadastro', Application.hash) > 0) then
  begin
    DMConnection.IniciarLoginConnection;

    if Assigned(FViewMain) then
      FViewMain.Free;

    TFViewGerenciarUsuario.Display('', @DisplayMainView);
  end
  else
    DMConnection.InitApp(@StartApplication, @UnauthorizedAccessProc);
end.
